import __request__ from "routing/request";
export function list(page = 1, per_page = 50, query) {
  return __request__("GET", "/events/definitions", null, { "page": page, "per_page": per_page, "query": query }, {
    "Accept": ["application/json"]
  });
}
export function create(schedule2 = true, JSONBody) {
  return __request__("POST", "/events/definitions", JSONBody, { "schedule": schedule2 }, {
    "Accept": ["application/json"]
  });
}
export function bulkDelete(Entitiestoremove) {
  return __request__("POST", "/events/definitions/bulk_delete", Entitiestoremove, {}, {
    "Accept": ["application/json"]
  });
}
export function bulkSchedule(Eventdefinitionstoenable) {
  return __request__("POST", "/events/definitions/bulk_schedule", Eventdefinitionstoenable, {}, {
    "Accept": ["application/json"]
  });
}
export function bulkUnschedule(Eventdefinitionstodisable) {
  return __request__("POST", "/events/definitions/bulk_unschedule", Eventdefinitionstodisable, {}, {
    "Accept": ["application/json"]
  });
}
export function getById(JSONbody) {
  return __request__("POST", "/events/definitions/byIds", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function getPage(sort = "title", page = 1, per_page = 50, query, filters, order = "asc") {
  return __request__("GET", "/events/definitions/paginated", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function validate(JSONbody) {
  return __request__("POST", "/events/definitions/validate", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function validateByJSONbody(JSONbody) {
  return __request__("POST", "/events/definitions/validate/cron_expression", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function get(definitionId) {
  return __request__("GET", `/events/definitions/${definitionId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function update(definitionId, schedule2 = true, JSONBody) {
  return __request__("PUT", `/events/definitions/${definitionId}`, JSONBody, { "schedule": schedule2 }, {
    "Accept": ["application/json"]
  });
}
export function remove(definitionId) {
  return __request__("DELETE", `/events/definitions/${definitionId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function clearNotificationQueue(definitionId) {
  return __request__("PUT", `/events/definitions/${definitionId}/clear-notification-queue`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function duplicate(definitionId) {
  return __request__("POST", `/events/definitions/${definitionId}/duplicate`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function execute(parameters, definitionId) {
  return __request__("POST", `/events/definitions/${definitionId}/execute`, parameters, {}, {
    "Accept": ["application/json"]
  });
}
export function schedule(definitionId) {
  return __request__("PUT", `/events/definitions/${definitionId}/schedule`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function unschedule(definitionId) {
  return __request__("PUT", `/events/definitions/${definitionId}/unschedule`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getWithContext(definitionId) {
  return __request__("GET", `/events/definitions/${definitionId}/with-context`, null, {}, {
    "Accept": ["application/json"]
  });
}
